import { i18n } from '@/locales';
const lc = 'views.user_management.';
const pageLc = 'views.user_management_page.';
export const componentInfo = {
    UserBasicInfo: {
        componentName: 'UserBasicInfo',
        pageType: 'basic-info',
        title: i18n.t(`${pageLc}basic_info`),
        confirmTitle: i18n.t(`${pageLc}cancel_edit_basic_info`),
        key: 'UserBasicInfo',
    },
};
export const leaveDateUsage = [
    {
        text: i18n.t(`${lc}used`),
        value: true,
    },
    {
        text: i18n.t(`${lc}not_use`),
        value: false,
    },
];
